<template>
  <v-form>
    <v-select
      label="Module"
      name="module"
      item-text="code"
      item-value="_id"
      :items="modules"
      :value="value.moduleId"
      @input="onInput('moduleId', $event)"
    />
    <v-select
      label="Unit"
      name="trainingUnitCodes"
      item-text="code"
      item-value="code"
      :items="units"
      :value="value.trainingUnitCodes"
      @input="onInput('trainingUnitCodes', $event)"
      multiple
      chips
      deletable-chips
    />
    <v-autocomplete
      label="Trainer"
      name="trainer"
      hint="Search by name, email, or phone number"
      :items="trainers"
      :loading="$apollo.queries.trainers.loading"
      :filter="filterTrainer"
      item-text="person.name"
      item-value="_id"
      clearable
      hide-no-data
      :value="value.trainerId"
      @input="onInput('trainerId', $event)"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ _.get(item, 'person.name') }}</v-list-item-title>
          <v-list-item-subtitle><v-icon x-small>perm_identity</v-icon> {{ _.get(item, 'person.personId') }}</v-list-item-subtitle>
          <v-list-item-subtitle v-show="!!_.get(item, 'person.email')"><v-icon x-small>email</v-icon> {{ _.get(item, 'person.email') }}</v-list-item-subtitle>
          <v-list-item-subtitle v-show="!!_.get(item, 'person.phoneNumber')"><v-icon x-small>smartphone</v-icon> {{ _.get(item, 'person.phoneNumber') }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <v-text-field
      label="Venue"
      name="venue"
      :value="value.venue"
      @input="onInput('venue', $event)"
    />
    <date-input
      label="Scheduled date"
      name="scheduledDate"
      :value="value.scheduledDate"
      @input="onInput('scheduledDate', $event)"
      clearable
    />
    <date-input
      label="Completed date"
      name="completionDate"
      :value="value.completionDate"
      @input="onInput('completionDate', $event)"
      clearable
    />
  </v-form>
</template>

<script>
import gql from 'graphql-tag'

import DateInput from '../inputs/DateInput.vue'

export default {
  name: 'SessionForm',

  components: {
    DateInput
  },

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    modules: [],
    trainers: []
  }),

  computed: {
    units () {
      return this.module?.units ?? []
    }
  },

  apollo: {
    modules: {
      query: gql`query {
        modules: trainingModuleMany(limit: 0, sort: CODE_DESC) {
          _id
          code
        }
      }`,
      error (e) { this.onError(e) }
    },

    module: {
      query: gql`query TrainingModule($id: MongoID!) {
        module: trainingModuleById(_id: $id) {
          _id
          units {
            _id
            code
          }
        }
      }`,
      variables () {
        return {
          id: this.value.moduleId
        }
      },
      skip () {
        return !this.value.moduleId
      },
      error (e) { this.onError(e) }
    },

    trainers: {
      query: gql`query {
        trainers: trainerMany(limit: 0) {
          _id
          personId
          person {
            _id
            personId
            name
            email
            phoneNumber
          }
        }
      }`,
      error (e) { this.onError(e) }
    }
  },

  methods: {
    onInput (key, value) {
      const o = {
        ...this.value,
        [key]: value
      }
      this.$emit('input', o)
    },

    filterTrainer (item, queryText) {
      return [
        item.person?.name,
        item.person?.personId,
        item.person?.email ?? '',
        item.person?.phoneNumber ?? ''
      ].join('').toLowerCase().indexOf(queryText.toLowerCase()) > -1
    }
  }
}
</script>
